const ADMIN_ROLE = "ADMIN";
const CLIENT_ROLE = "CLIENT";
const EMPLOYEE_ROLE = "EMPLOYEE";
const MANAGER_ROLE = "MANAGER";
const EMPLOYEE_CUSTOMS_TL_ROLE = "EMPLOYEE_CUSTOM_TL";
const EMPLOYEE_FIRST_MILE_TL_ROLE = "EMPLOYEE_FIRST_MILE_TL";
const EMPLOYEE_IN_BOUND_TL_ROLE = "EMPLOYEE_IN_BOUND_TL";
const EMPLOYEE_OUT_BOUND_TL_ROLE = "EMPLOYEE_OUT_BOUND_TL";
const EMPLOYEE_LAST_MILE_TL_ROLE = "EMPLOYEE_LAST_MILE_TL";
const EMPLOYEE_FINANCE_HEAD_ROLE = "EMPLOYEE_FINANCE_HEAD";
const EMPLOYEE_FINANCE_MANAGER_ROLE = "EMPLOYEE_FINANCE_MANAGER";
const EMPLOYEE_FIRST_MILE_PA_ROLE = "EMPLOYEE_FIRST_MILE_PA";
const EMPLOYEE_RETURN_TL_ROLE = "EMPLOYEE_RETURN_TL";

module.exports = {
  ADMIN_ROLE,
  CLIENT_ROLE,
  EMPLOYEE_ROLE,
  MANAGER_ROLE,
  EMPLOYEE_CUSTOMS_TL_ROLE,
  EMPLOYEE_FIRST_MILE_TL_ROLE,
  EMPLOYEE_IN_BOUND_TL_ROLE,
  EMPLOYEE_OUT_BOUND_TL_ROLE,
  EMPLOYEE_LAST_MILE_TL_ROLE,
  EMPLOYEE_FINANCE_HEAD_ROLE,
  EMPLOYEE_FINANCE_MANAGER_ROLE,
  EMPLOYEE_FIRST_MILE_PA_ROLE,
  EMPLOYEE_RETURN_TL_ROLE
};
